"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBool = exports.getNumber = exports.getString = exports.unformatLicenseplate = exports.formatLicenseplate = void 0;
const formatLicenseplate = licencePlate => {
    licencePlate = licencePlate.replace(/-/g, "").toUpperCase();
    // licencePlates for diplomates should not be formatted
    var diplomateLicencePlateRegex = /^CD[ABFJNST]\d{1,3}$/; //for example: CDB1 of CDJ45
    if (licencePlate.match(diplomateLicencePlateRegex)) {
        return licencePlate;
    }
    var licencePlateRegexes = [
        /^([A-Z]{2})(\d{2})(\d{2})$/,
        /^(\d{2})(\d{2})([A-Z]{2})$/,
        /^(\d{2})([A-Z]{2})(\d{2})$/,
        /^([A-Z]{2})(\d{2})([A-Z]{2})$/,
        /^([A-Z]{2})([A-Z]{2})(\d{2})$/,
        /^(\d{2})([A-Z]{2})([A-Z]{2})$/,
        /^(\d{2})([A-Z]{3})(\d{1})$/,
        /^(\d{1})([A-Z]{3})(\d{2})$/,
        /^([A-Z]{2})(\d{3})([A-Z]{1})$/,
        /^([A-Z]{1})(\d{3})([A-Z]{2})$/,
        /^([A-Z]{3})(\d{2})([A-Z]{1})$/,
        /^([A-Z]{1})(\d{2})([A-Z]{3})$/,
        /^(\d{1})([A-Z]{2})(\d{3})$/,
        /^(\d{3})([A-Z]{2})(\d{1})$/,
        /^(\d{3})(\d{2})([A-Z]{1})$/,
        /^([A-Z]{3})(\d{2})(\d{1})$/,
        /^([A-Z]{3})([A-Z]{2})(\d{1})$/ //       XXX-XX-9
    ];
    for (var i = 0; i < licencePlateRegexes.length; i++) {
        if (licencePlate.match(licencePlateRegexes[i])) {
            return licencePlate.replace(licencePlateRegexes[i], "$1-$2-$3");
        }
    }
    return licencePlate;
};
exports.formatLicenseplate = formatLicenseplate;
const unformatLicenseplate = licencePlate => {
    return licencePlate.replace(/-/g, "").toUpperCase();
};
exports.unformatLicenseplate = unformatLicenseplate;
const getString = (value, defaultValue) => {
    return value ? value : defaultValue;
};
exports.getString = getString;
const getNumber = (value, defaultValue) => {
    return value ? parseInt(value) : defaultValue;
};
exports.getNumber = getNumber;
const getBool = (value, defaultValue) => {
    return value ? value : defaultValue;
};
exports.getBool = getBool;
//# sourceMappingURL=util.js.map